export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'frontend',
    name: '前端开发',
    icon: 'ri-reactjs-line',
    description: 'HTML/CSS/JavaScript、React、Vue、Angular 等前端技术的前沿动态与实战教程',
    articleCount: 128,
  },
  {
    slug: 'backend',
    name: '后端开发',
    icon: 'ri-server-line',
    description: 'Java、Go、Python、Node.js 等后端技术栈的架构设计与最佳实践',
    articleCount: 156,
  },
  {
    slug: 'mobile',
    name: '移动开发',
    icon: 'ri-smartphone-line',
    description: 'iOS、Android、Flutter、React Native 等移动端开发技术深度解析',
    articleCount: 89,
  },
  {
    slug: 'ai',
    name: 'AI / 机器学习',
    icon: 'ri-brain-line',
    description: '人工智能、深度学习、大语言模型、计算机视觉等前沿 AI 技术探索',
    articleCount: 203,
  },
  {
    slug: 'opensource',
    name: '开源项目',
    icon: 'ri-git-repository-line',
    description: '优质开源项目推荐、源码解读、贡献指南与开源社区动态',
    articleCount: 97,
  },
  {
    slug: 'devops',
    name: 'DevOps',
    icon: 'ri-settings-3-line',
    description: 'CI/CD、容器化、云原生、监控告警等 DevOps 工程化实践指南',
    articleCount: 74,
  },
  {
    slug: 'database',
    name: '数据库',
    icon: 'ri-database-2-line',
    description: 'MySQL、PostgreSQL、MongoDB、Redis 等数据库性能优化与架构设计',
    articleCount: 63,
  },
  {
    slug: 'language',
    name: '编程语言',
    icon: 'ri-code-s-slash-line',
    description: 'Rust、TypeScript、Kotlin、Zig 等新兴编程语言深度探索与对比分析',
    articleCount: 112,
  },
];

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((c) => c.slug === slug);
}